import {wrap} from '@codeurs/front'
import React from 'react'
import {PageData} from '../../types'
import {useTranslation} from '../../util/i18n'
import {getUrlByKey} from '../../util/nav'
import {style} from '../../util/style'
import {Block, Blocks, BlockType} from '../blocks/Blocks'
import {Hero} from '../layout/Hero'
import {Layout} from '../layout/Layout'
import {Overview} from '../layout/Overview'

const styles = style('home')

export const Home: React.FC<PageData> = wrap(Layout)(({...props}) => {
	const {title, hero, blocks, main_pages, news, agenda} = props
	const t = useTranslation()
	const agendaLoadMoreLink = getUrlByKey(main_pages, 'agenda')

	const processedBlocks: Array<BlockType> =
		blocks &&
		blocks.map((block) => {
			if (block.type === 'agenda')
				return {
					type: 'custom',
					render: () => (
						<Block>
							<Overview
								title={t.agenda.title}
								layout="event"
								items={agenda.items}
								maxBeforeLoadMore={3}
								disableLoadmoreByLink={agendaLoadMoreLink}
							/>
						</Block>
					)
				}
			return block
		})

	return (
		<div className={styles()}>
			<Hero {...hero} title={(hero && hero.title) || title} mod="home" />
			<Blocks
				blocks={processedBlocks}
				container={true}
				main_pages={main_pages}
				news={news}
			/>
		</div>
	)
})
